module.exports = __webpack_public_path__ + "assets/img/date.d2b839fc.svg";